import {Box, Stack, Typography} from '@mui/material';
import {Question} from '@cp/model';
import QuestionFormStatusNoteDialog from '../../../components/QuestionFormDialog/QuestionFormStatusNoteDialog';

export interface AdminQuestionReviewQuestionStatusNoteProps {
  question: Question;
}

export default function AdminQuestionReviewQuestionStatusNote({question}: AdminQuestionReviewQuestionStatusNoteProps) {
  if (!question.statusNote) return null;

  return (
    <Box
      sx={{
        p: 2,
        bgcolor: 'grey.50',
        borderRadius: 1,
        border: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Stack direction="row" spacing={2} alignItems="flex-start">
        <Box sx={{flex: 1}}>
          <Typography variant="body2" color="text.secondary" sx={{mb: 0.5, fontWeight: 500}}>
            Status Note:
          </Typography>
          <Typography variant="body2" sx={{wordBreak: 'break-word'}}>
            {question.statusNote.length > 150 ? `${question.statusNote.substring(0, 150)}...` : question.statusNote}
          </Typography>
        </Box>
        <QuestionFormStatusNoteDialog statusNote={question.statusNote} />
      </Stack>
    </Box>
  );
}
